import EmployeeSelect from '../../../../elements/Select/Employee/EmployeesSelect'
import React, { Component } from 'react'
import { Col, Form, Input, Row } from 'antd'
import { get } from 'lodash'

import { defaultFormItemLayout } from '../../../../modules/FormItems'

const { TextArea } = Input

function LinkedMemberForm(props) {
  const { getFieldDecorator } = props.form
  const { link } = props

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <Form.Item label="Name" {...defaultFormItemLayout}>
            {getFieldDecorator('member._id', {
              initialValue: get(link, 'member._id'),
              rules: [{ required: true, message: "Name can't be empty " }],
            })(<EmployeeSelect placeholder={'Manager'} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()((LinkedMemberForm))
